import React from "react";

// components
import ProfileHeader from "../ProfileHeader/ProfileHeader";
import Share from "../Share/Share";
import Trending from "../Trending/Trending";
import Category from "../Category/Category";

import styles from "./styles.module.scss";

const Content = () => {
  return (
    <div className={styles.profile__content}>
      <ProfileHeader />
      <Trending />
      <Share />
      <Category />
    </div>
  );
};

export default Content;
